import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule, UserService } from './core';
import { ToastrModule } from 'ngx-toastr';
import { SessionExpirationAlert } from 'session-expiration-alert';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { ResourcesComponent } from './resources/resources.component';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas, faFileExcel, faCheckSquare, faSquare } from '@fortawesome/free-solid-svg-icons';

export function appUserServiceFactory(userService: UserService) {
  return () => userService.getUser();
}

@NgModule({
  declarations: [AppComponent, ResourcesComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgbModule,
    ToastrModule.forRoot(),
    SessionExpirationAlert.forRoot(),
    CoreModule,
      AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas);
        library.addIcons(faFileExcel, faCheckSquare, faSquare);
    }
}
